/** Video bytes stay outside Git and the application server. */
export const DEMO_MEDIA = {
  source:
    'https://www.dropbox.com/scl/fi/43wd8knqubw21erjufp1a/source.mp4?rlkey=rq1iwhv8reicvewyr1spe7ocl&raw=1',
  result:
    'https://www.dropbox.com/scl/fi/dklovrrkkvl28ybhumqh5/result.mp4?rlkey=bdu1mnw8jr4lawc6o724fy2u0&raw=1',
  magic:
    'https://www.dropbox.com/scl/fi/1n4j0izm60ru8qms9s6ek/magic.mp4?rlkey=2kyw6xb4mi9mgywjphw4kquc3&raw=1',
  travel:
    'https://www.dropbox.com/scl/fi/n6u1efcjh9xpewrv8af5f/travel.mp4?rlkey=gbn44tclupvs0w4w4zogtixdt&raw=1',
  croissantResult:
    'https://www.dropbox.com/scl/fi/agt6yau7hepecmr7u5s2o/croissant-result.mp4?rlkey=mnzjrvzyob9509vfpfmpdrzwj&raw=1',
} as const;

export type DemoPreview = 'source' | 'magic' | 'travel';

export const DEMO_EXAMPLES = {
  drink: {
    source: DEMO_MEDIA.source,
    result: DEMO_MEDIA.result,
    sourcePoster: '/landing-demo/source.jpg',
    resultPoster: '/landing-demo/result.jpg',
  },
  croissant: {
    source: DEMO_MEDIA.magic,
    result: DEMO_MEDIA.croissantResult,
    sourcePoster: '/landing-demo/magic.jpg',
    resultPoster: '/landing-demo/croissant-result.jpg',
  },
} as const;

export type DemoExample = keyof typeof DEMO_EXAMPLES;
